// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:11.686Z
// Property: Ventura Lofts Apartments (ID: 6737460151191772)
// Collections: 36 amenities, 19 floorplans (live), 30 photos, 76 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191772",
  "property_external_id": "4871564",
  "property_zillow_url": "https://www.zillow.com/apartments/houston-tx/2401-s-gessner-rd/5Xjv3x/",
  "property_apartments_url": "https://www.apartments.com/ventura-lofts-houston-tx/1hs4k16",
  "property_google_business_url": "https://www.google.com/maps/place/Ventura+Lofts/data=!4m2!3m1!1s0x0:0xc449b3419d3022a5?sa=X&ved=2ahUKEwjDoaiywLySAxXOOzQIHfKaFpMQ_BJ6BAg-EAA&hl=en&gl=us",
  "property_linkedin_url": "https://fr.linkedin.com/company/southhampton-management",
  "property_hubspot_id": "17321213544",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ventura-lofts-apartments",
  "property_name": "Ventura Lofts Apartments",
  "property_website_url": "https://www.venturalofts-houston.com/",
  "property_domain": "https://www.venturalofts-houston.com/",
  "property_address": "2401 S Gessner Rd",
  "property_full_address": "2401 S Gessner Rd, Houston, TX 77063",
  "property_address_1": "2401 S Gessner Rd",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77063-2044",
  "property_address_zip": "77063",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Mid West",
  "property_address_latitude": "29.7414759",
  "property_address_longitude": "-95.5378959",
  "property_email": "venturalofts@rreafresidential.com",
  "property_phone": "(832) 494-1200",
  "property_call_tracking_phone": "832-400-1286",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Ventura Lofts Apartments in Houston, TX! Choose from stylish one, two, or three-bedroom floor plans, complemented by exceptional amenities like a fitness center, rooftop terrace, and gameroom. Enjoy community activities, pet-friendly spaces, and more. Find your new home today – browse availability or schedule a tour!",
  "property_long_description": "**Welcome to Ventura Lofts Apartments in Houston, TX!**\n\nDiscover the perfect blend of luxury and convenience at Ventura Lofts Apartments. Our thoughtfully designed community offers a variety of spacious floor plans, including elegant one-bedroom, two-bedroom, and three-bedroom apartments that cater to your lifestyle needs. \n\nExperience exceptional amenities that elevate your living experience. Stay fit in our modern fitness center, unwind in the inviting clubhouse, or soak up the sun on our scenic roof terrace. With controlled access, a dedicated property manager on-site, and community-wide WiFi, your peace of mind is our priority. \n\nEmbrace a work-life balance with our business center and conference rooms, perfect for remote work or meetings. Take advantage of our shuttle service to the train for effortless commuting, while on-site retail makes daily errands a breeze. \n\nWe know pets are part of the family! That's why Ventura Lofts features a pet play area and a convenient pet washing station, ensuring your furry friends feel right at home. Join in on our planned social activities or relax in our media center and gameroom. \n\nWhether you’re enjoying a barbecue at the grill, sipping a morning coffee at our breakfast concierge, or connecting with neighbors in the multi-use room, Ventura Lofts Apartments is designed for your happiness.\n\nFind your new home today—browse our availability or schedule a tour to visit our vibrant community! Experience Houston living at its finest at Ventura Lofts Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8f4-77b6-afbd-0c5124ac3207.webp",
  "property_featured_image_media": {
    "alt_text": "Modern lounge area with a TV, stylish seating, and large windows.",
    "public_id": "019e1e1b-d8f4-77b6-afbd-0c5124ac3207",
    "storage_key": "property/6737460151191772/019e1e1b-d8f4-77b6-afbd-0c5124ac3207.webp",
    "width": 984,
    "height": 656
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "265",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.35849056603773",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$175\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No more than two animals are allowed per apartment. Aggressive breeds will not be allowed.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://venturaloftsapartments.loftliving.com/login",
  "property_apply_now_url": "https://8754822.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a397-711e-a0fa-881abd5a777a.webp",
  "property_primary_logo_media": {
    "alt_text": "Ventura Lofts Apartment Homes logo",
    "public_id": "019e1e1b-a397-711e-a0fa-881abd5a777a",
    "storage_key": "property/6737460151191772/019e1e1b-a397-711e-a0fa-881abd5a777a.webp",
    "width": 733,
    "height": 330
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a58d-706d-b166-a2d536c15364.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ventura Lofts Apartment Homes logo",
    "public_id": "019e1e1b-a58d-706d-b166-a2d536c15364",
    "storage_key": "property/6737460151191772/019e1e1b-a58d-706d-b166-a2d536c15364.webp",
    "width": 733,
    "height": 330
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a58d-706d-b166-a2d536c15364.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ventura Lofts Apartment Homes logo",
    "public_id": "019e1e1b-a58d-706d-b166-a2d536c15364",
    "storage_key": "property/6737460151191772/019e1e1b-a58d-706d-b166-a2d536c15364.webp",
    "width": 733,
    "height": 330
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a56b-739f-bbf4-7b193207e6fc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ventura Lofts Apartment Homes logo",
    "public_id": "019e1e1b-a56b-739f-bbf4-7b193207e6fc",
    "storage_key": "property/6737460151191772/019e1e1b-a56b-739f-bbf4-7b193207e6fc.webp",
    "width": 733,
    "height": 330
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "952 - 1635",
  "property_sqft_min": "952",
  "property_sqft_max": "1635",
  "property_price_range": "1349 - 2275",
  "property_price_min": "1349",
  "property_price_max": "2275",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/people/Ventura-Lofts-Apartments/61554256410926/",
  "property_instagram_url": "https://www.instagram.com/ventura_lofts_rr_living/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJEWqDwRTDQIYRpSIwnUGzScQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/ventura-loft-apartments-houston-3",
  "property_tiktok_url": "https://www.tiktok.com/@ventura.lofts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ventura Lofts Apartments",
  "property_home_romance_title": "Embrace Your Dream Lifestyle at Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Ventura Lofts is an exquisite <a href=\"/floor-plans/\">apartment home</a> community located west of downtown Houston, Texas. Our community is situated within a park-like setting, with beautifully landscaped grounds and mature lush trees. Proximity to major thoroughfares provides easy access to shopping, local dining, and irresistible entertainment. Discover your future here at Ventura Lofts.</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Houston, TX, the <a href=\"/neighborhood/\">neighborhood</a> surrounding Ventura Lofts has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "At Ventura Lofts Apartments in Houston, TX, stylish one, two, and three-bedroom layouts await you. Our resort-like amenities, from a sparkling pool and fitness center to a cozy clubhouse and serene picnic area, create a lifestyle of comfort. Picture yourself living here, where modern elegance meets everyday convenience!",
  "property_home_neighborhood_blurb": "Discover vibrant living at Ventura Lofts Apartments in Houston, TX! Choose from our spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Explore the surrounding neighborhood and uncover local favorites and nearby points of interest. See what's around our community today!",
  "property_home_reviews_blurb": "At Ventura Lofts Apartments in Houston, we pride ourselves on creating a welcoming community. Residents rave about our dedicated staff, with one stating, “Wendy and Bree are so helpful... they certainly help make my time at this complex much more comfortable.” Experience our vibrant amenities and stellar service today!",
  "property_neighborhood_blurb": "<p>Ideally located in Houston, TX, the <a href=\"/neighborhood/\">neighborhood</a> surrounding Ventura Lofts has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Our community offers some of the best amenities in <a href=\"/floor-plans/\">apartment</a> home living. Community amenities include a movie theater and media room, business center, sauna, shimmering swimming pool, soothing spa, picnic area with a barbecue, and a courtyard with a sundeck. Enjoy the high-speed internet access, covered parking, beautiful landscaping, as well as on-call and on-site maintenance. Call us today to schedule your tour of Ventura Lofts and see what you’ve been missing.</p>",
  "property_applynow_blurb": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! Choose from stunning one-, two-, or three-bedroom floor plans and enjoy premium amenities like a fitness center, roof terrace, and pet-friendly areas. Find your new home and lease online today! Explore all our offerings now!",
  "property_contactus_blurb": "Discover your perfect home at Ventura Lofts Apartments in Houston, TX! Choose from stylish one, two, or three-bedroom floor plans designed for modern living. Ready to make a move? Have questions? Contact our leasing team today for personalized assistance and let us help you find your ideal apartment!",
  "property_faqs_blurb": "Discover the perfect living space at Ventura Lofts Apartments in Houston, TX! Explore our versatile floor plans, featuring one, two, and three-bedroom options tailored to fit your lifestyle. Have questions? Browse our FAQs page for answers about our community and find your ideal apartment today!",
  "property_floorplans_blurb": "<p>We are proud to offer a variety of spacious floor plans with one, two, and three bedroom apartment homes for rent. Designed for comfort, Ventura Lofts apartment homes come <a href=\"/amenities/\">equipped</a> with gourmet kitchens, stainless steel appliances, and a pantry. A balcony or a patio, hardwood floors, vaulted ceilings, and walk-in closets are standard, as well as a washer and dryer included. Ventura Lofts is a pet-friendly community and welcomes your entire family.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Ventura Lofts Apartments in Houston, TX! Choose from our thoughtfully designed one, two, and three-bedroom layouts. Enjoy exceptional amenities like a fitness center, rooftop terrace, and pet play area. Use our interactive community map to find available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover the perfect living space at Ventura Lofts Apartments in Houston, TX! Choose from our spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and elevate your apartment experience! ",
  "property_residentaccess_blurb": "Welcome to Ventura Lofts Apartments in vibrant Houston, TX! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Access your resident portal to effortlessly pay rent, schedule maintenance, and more. Join our community today for a seamless rental experience!",
  "property_reviews_blurb": "At Ventura Lofts Apartments in Houston, our residents love the attentive service from our dedicated staff. As one reviewer notes, \"Wendy and Gail... are very nice and helpful,\" ensuring every need is met swiftly. Experience a harmonious blend of comfort, community, and care—your perfect home awaits! ",
  "property_created_at": "1752257095448",
  "property_scheduletour_blurb": "Discover your perfect home at Ventura Lofts Apartments in Houston, TX! Choose from spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Ready to experience the vibrant community? Schedule a tour today and see what our residents say about living at Ventura Lofts! Your new beginning awaits!",
  "property_thankyou_blurb": "Thank you for your interest in Ventura Lofts Apartments in Houston, TX! We offer spacious one, two, and three-bedroom floor plans to fit your lifestyle. A member of our team will contact you shortly to assist with your apartment search. Explore the perfect home with us today!",
  "property_virtualtours_blurb": "<p>At Ventura Lofts, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Ventura Lofts Apartments",
  "property_seo_title_home": "Ventura Lofts Apartments | Apartments in Houston, TX",
  "property_seo_description_home": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! Choose from spacious one, two, and three-bedroom floor plans that cater to your lifestyle. Enjoy top-notch amenities including a fitness center, roof terrace, and pet-friendly features like a play area and washing station. Benefit from on-site services such as concierge, business center, and shuttle to the train. Join our vibrant community with planned social activities and a gameroom. Experience luxury city living—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! Explore our diverse floor plans, including cozy one-bedroom, spacious two-bedroom, and family-friendly three-bedroom options. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal home at Ventura Lofts Apartments in Houston, TX! Our community offers spacious one, two, and three-bedroom floor plans, complemented by exceptional amenities including a fitness center, relaxing roof terrace, and a pet-friendly environment with a play area and washing station. Enjoy convenience with on-site retail, planned social activities, and a shuttle to the train. Experience modern living—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Discover your dream lifestyle at Ventura Lofts Apartments in Houston, TX! Explore our stunning photo gallery showcasing stylish one, two, and three-bedroom floor plans, along with exceptional amenities like a fitness center, rooftop terrace, and pet-friendly areas. Enjoy community-wide WiFi, a clubhouse, and dedicated concierge services, perfect for modern living. Picture yourself living here and experience the vibrant community with planned social activities and convenient on-site retail. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Ventura Lofts Apartments Apartments",
  "property_seo_description_virtualtours": "Discover your dream home at Ventura Lofts Apartments in Houston, TX! Explore our diverse floor plans featuring one, two, and three-bedroom options designed for modern living. Take a virtual tour of our vibrant community and spacious apartments for rent today! Experience comfort and style at Ventura Lofts!",
  "property_seo_title_interactivemap": "Interactive Map | Ventura Lofts Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Ventura Lofts Apartments in Houston, TX! Choose from spacious one, two, and three-bedroom floor plans while enjoying a wealth of amenities, including a state-of-the-art fitness center, vibrant clubhouse, serene roof terrace, and more. Explore our interactive community map to find your perfect apartment, view pricing, and take the first step towards an extraordinary lifestyle. Your new home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Discover the vibrant surroundings of Ventura Lofts Apartments in Houston, TX! Explore our diverse one, two, and three-bedroom floor plans, and see what's around our community. From local favorites to nearby points of interest, your perfect neighborhood awaits. Join us today and experience the best of urban living!",
  "property_seo_title_contact": "Contact Us | Ventura Lofts Apartments",
  "property_seo_description_contact": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! With a variety of floor plans to choose from, including one, two, and three-bedroom options, we have the perfect apartment to suit your lifestyle. Have questions? Contact our leasing team today to learn more about our vibrant community and available units!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! With thoughtfully designed one, two, and three-bedroom floor plans, our community features top-tier amenities including a fitness center, rooftop terrace, and pet play area. Curious about our offerings? Visit our FAQs page for answers to all your questions and learn how we make everyday living extraordinary.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Discover why residents love Ventura Lofts Apartments in Houston, TX! Explore spacious one, two, and three-bedroom floor plans tailored for modern living. Enjoy top-notch amenities including a fitness center, rooftop terrace, and clubhouse, along with pet-friendly features and planned social activities. Don't just take our word for it—see what our residents have to say about their vibrant community experience! Your perfect apartment awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Ventura Lofts Apartments in Houston, TX! Choose from our spacious floor plans—one, two, or three bedrooms. Enjoy top-notch amenities including a fitness center, concierge service, clubhouse, and a stunning roof terrace. Our pet-friendly community features a play area, washing station, and vibrant social activities. Don't miss out on convenient online services, business center access, and our shuttle service to the train. Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Ventura Lofts Apartments",
  "property_seo_description_residentaccess": "\"Welcome to the Ventura Lofts Apartments resident portal in Houston, TX! Easily manage your living experience by logging in to pay rent, schedule maintenance, and access community updates. Join us for a seamless resident experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Ventura Lofts Apartments",
  "property_seo_description_referafriend": "\"Refer a friend to Ventura Lofts Apartments in Houston, TX, and embrace an amazing community together! Discover why great friends make great neighbors—share the joy of upscale living today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Ventura Lofts Apartments",
  "property_seo_description_scheduletour": "Discover your dream home at Ventura Lofts Apartments in Houston, TX! Explore our stunning community and stylish lofts. Schedule a tour today to see what makes us the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Ventura Lofts Apartments",
  "property_seo_description_privacy": "\"Protecting your privacy is our priority at Ventura Lofts Apartments in Houston, TX. Discover how we safeguard your information and ensure a secure living experience. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Ventura Lofts Apartments",
  "property_seo_description_accessibility": "Discover Ventura Lofts Apartments in Houston, TX, where accessibility matters! Our commitment to digital inclusion ensures all residents can easily navigate our community online. Explore our Accessibility Statement to see how we're creating a welcoming environment for everyone. Join us and experience the difference today!",
  "property_seo_title_sitemap": "Sitemap | Ventura Lofts Apartments",
  "property_seo_description_sitemap": "Discover your ideal home at Ventura Lofts Apartments in Houston, TX. Explore our sitemap for easy navigation of our exceptional amenities, floor plans, and community features. View our website sitemap now and start your journey to vibrant urban living!",
  "property_seo_title_thankyou": "Thank You | Ventura Lofts Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Ventura Lofts Apartments in Houston, TX! We appreciate your submission, and our dedicated team will reach out to you shortly to assist with your apartment search. Discover your future home today!",
  "property_seo_title_pets": "Pet Policy | Apartments in Houston, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293616517",
  "amenities": [
    {
      "id": "ec_74e85a04a68c7304bbadce7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92f9c03906253ebe9533b14d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7535a038d0150b9661fc4f41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91a32d5171b900e7f2baed7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b6722512da86b56e24ca54c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard and Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30d698978f7b4ef7c8b3a515",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65a418faf7501fb9b67784aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59a9481a7dc70d54de37bbe8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8d1f88077027c7f5d1adc22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_339e985162ce03ba633fe482",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Movie Theater and Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4589bd28bc9eec98879f624",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ddb38d324a6ebee67c830b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00504302f6a0fe58c253e074",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8306a3f6848467093674f60c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4273bc6508ba5f6680343419",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ba0309aefd2811c888063ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d85a891a18614e82a20caaa0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Splash Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7fdcc425b03f4548268b515",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e02b9301cf7c089e836f65d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "All‑electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5ce4994b570e6e0350eabd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12bcd75a04dc70c968335d4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e5bfca75da68688cc9c018e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Central Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87d3c635b0aa44a411033e69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98d0fc996da1d25325107afc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54a4961fecef08b35d8fa6fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a106dd8678bfbccee55e80f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_370cfd61ebbd49cd8556e7fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Loft*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cafa153b3f14894f5b9a7882",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_038c46f6188772507bee24b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61060c99e1ca2f22e1a127ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8042f08993f1bd23026e1a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_673884f99c1debc7ea3bb4df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91f9e21d648a0842e3d81d2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970b6b1eee0f4428feafa49a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b9a10c3d4fa8bb63c80065c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_809694f9a95cb6da360dfb40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_340dc719-84bd-4e56-9420-c988fd21e1c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-fd6f-745d-891a-8f487186e4b8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lap lanes and surrounding brick patio.",
        "public_id": "01a09221-fd6f-745d-891a-8f487186e4b8",
        "storage_key": "property/6737460151191772/01a09221-fd6f-745d-891a-8f487186e4b8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax poolside at our beautiful outdoor swimming pool, complete with lap lanes and a spacious, modern patio area.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lap lanes and surrounding brick patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d3228ea-b125-4c27-aba2-54fb5faf7e10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-e319-7656-ba51-acebaa27a463.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and large windows overlooking the exterior.",
        "public_id": "01a09221-e319-7656-ba51-acebaa27a463",
        "storage_key": "property/6737460151191772/01a09221-e319-7656-ba51-acebaa27a463.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring ample seating and ample natural light.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and large windows overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19ceb65e-d9f0-4915-a4c6-b0492ca08c5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-f716-7306-99a4-1c03bac28b31.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sectional sofa, coffee table, and bar stools.",
        "public_id": "01a09221-f716-7306-99a4-1c03bac28b31",
        "storage_key": "property/6737460151191772/01a09221-f716-7306-99a4-1c03bac28b31.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area and modern kitchen, perfect for entertaining. Features comfortable seating and a fully equipped kitchen.",
      "link": "",
      "alt_text": "Living room and kitchen area with a sectional sofa, coffee table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_692f0aba-431a-4b70-a183-2d9dd455ab9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-f68b-7661-97a2-6ec2412e06a4.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large white sofa, coffee table, and TV, opening to a bedroom.",
        "public_id": "01a09221-f68b-7661-97a2-6ec2412e06a4",
        "storage_key": "property/6737460151191772/01a09221-f68b-7661-97a2-6ec2412e06a4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Inviting living room featuring a comfortable sofa, modern entertainment center, and a view into a well-appointed bedroom. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a large white sofa, coffee table, and TV, opening to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0624315-6111-41f5-a67f-5167d359031b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-fd79-75f3-a5de-f0eb3d68d494.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "01a09221-fd79-75f3-a5de-f0eb3d68d494",
        "storage_key": "property/6737460151191772/01a09221-fd79-75f3-a5de-f0eb3d68d494.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a modern ceiling fan for optimal comfort. This inviting space offers a serene retreat.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d9918e4-04a8-4cf4-8b0e-526fd87162f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-e8f6-75cf-91de-352ba633793f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wooden cabinets, stainless steel appliances, and a granite island.",
        "public_id": "01a09221-e8f6-75cf-91de-352ba633793f",
        "storage_key": "property/6737460151191772/01a09221-e8f6-75cf-91de-352ba633793f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring ample cabinet space, sleek stainless steel appliances, and a spacious granite island perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with wooden cabinets, stainless steel appliances, and a granite island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82626ec5-6397-4af5-a5a3-23ed1b4b797d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-e4af-70fd-8d11-88e763295f7f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a09221-e4af-70fd-8d11-88e763295f7f",
        "storage_key": "property/6737460151191772/01a09221-e4af-70fd-8d11-88e763295f7f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek wood cabinetry, high-end stainless steel appliances, a deep sink, and elegant granite countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17ec69a0-5cff-4e05-959e-53881de42a9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-fd46-7753-a97b-4d83e03bc208.webp",
      "image_media": {
        "alt_text": "Spacious and modern apartment lobby with a reception desk, lounge seating, and a grand staircase.",
        "public_id": "01a09221-fd46-7753-a97b-4d83e03bc208",
        "storage_key": "property/6737460151191772/01a09221-fd46-7753-a97b-4d83e03bc208.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community lobby, featuring a sleek reception desk, comfortable seating areas, and an elegant staircase, perfect for making a great first impression.",
      "link": "",
      "alt_text": "Spacious and modern apartment lobby with a reception desk, lounge seating, and a grand staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82a259f7-73d8-41cc-9a29-079e4eb25cc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-e42d-742a-9c1b-a72caf4ae2ed.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a large mirror, wooden cabinets, and a glass-enclosed shower.",
        "public_id": "01a09221-e42d-742a-9c1b-a72caf4ae2ed",
        "storage_key": "property/6737460151191772/01a09221-e42d-742a-9c1b-a72caf4ae2ed.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with ample storage, a sleek shower, and tasteful decor.",
      "link": "",
      "alt_text": "Modern bathroom vanity with a large mirror, wooden cabinets, and a glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f766b726-252b-4a15-95aa-f05689231c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/01a09221-e62a-759a-8e3f-bc07da00c395.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with a soaking tub and separate glass-enclosed shower.",
        "public_id": "01a09221-e62a-759a-8e3f-bc07da00c395",
        "storage_key": "property/6737460151191772/01a09221-e62a-759a-8e3f-bc07da00c395.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and luxurious bathroom featuring a dual-sink vanity with granite countertops, a deep soaking tub, and a walk-in shower with elegant tile work.",
      "link": "",
      "alt_text": "Double vanity bathroom with a soaking tub and separate glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f795f2f7-6fb0-4dc6-b4d7-c3a2f7a33a46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-5c65-726e-b99f-501e84eaec66.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating areas, and kitchen.",
        "public_id": "019d076e-5c65-726e-b99f-501e84eaec66",
        "storage_key": "property/6737460151191772/019d076e-5c65-726e-b99f-501e84eaec66.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Enjoy our spacious community lounge, perfect for socializing or relaxing. Features include a pool table, comfortable seating, and a mini-kitchen area.",
      "link": "",
      "alt_text": "Community lounge with pool table, seating areas, and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42160833-6907-4434-823e-467317ea3822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-890b-710f-a798-1e011941c043.webp",
      "image_media": {
        "alt_text": "Lobby area with modern seating, a large TV, and decorative wall.",
        "public_id": "019d076e-890b-710f-a798-1e011941c043",
        "storage_key": "property/6737460151191772/019d076e-890b-710f-a798-1e011941c043.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, a large television, and contemporary decor.",
      "link": "",
      "alt_text": "Lobby area with modern seating, a large TV, and decorative wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9c60bfd-944d-464d-9ee7-26396dc7e1fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-a9f6-743a-a7b8-0b75b73c4169.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with bar stools and wine fridge in a communal space.",
        "public_id": "019d076e-a9f6-743a-a7b8-0b75b73c4169",
        "storage_key": "property/6737460151191772/019d076e-a9f6-743a-a7b8-0b75b73c4169.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a stylish and functional communal kitchen space, perfect for entertaining guests or casual gatherings, featuring a large island, modern appliances, and elegant decor.",
      "link": "",
      "alt_text": "Modern kitchen island with bar stools and wine fridge in a communal space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8bd030a-6c6c-4bc7-96c8-c8522966eac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-b907-7295-bb4e-9e66c341efa8.webp",
      "image_media": {
        "alt_text": "Treadmills and stationary bikes in a modern fitness center.",
        "public_id": "019d076e-b907-7295-bb4e-9e66c341efa8",
        "storage_key": "property/6737460151191772/019d076e-b907-7295-bb4e-9e66c341efa8.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio machines to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Treadmills and stationary bikes in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55665e4d-0a07-4ff8-923e-e4a9e29bf99e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84ed-740b-746c-9649-365418a2df49.webp",
      "image_media": {
        "alt_text": "Private movie theater with plush seating and a large screen.",
        "public_id": "019e84ed-740b-746c-9649-365418a2df49",
        "storage_key": "property/6737460151191772/019e84ed-740b-746c-9649-365418a2df49.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy movie nights in the community's private theater, featuring comfortable seating and a projector for an immersive cinematic experience.",
      "link": "",
      "alt_text": "Private movie theater with plush seating and a large screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c31e7f8-74d6-4938-890a-b4f0b4aa5793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84ed-7362-72fc-ae1b-b5a0bbb8dd78.webp",
      "image_media": {
        "alt_text": "Movie theater lobby with posters, popcorn machine, and seating.",
        "public_id": "019e84ed-7362-72fc-ae1b-b5a0bbb8dd78",
        "storage_key": "property/6737460151191772/019e84ed-7362-72fc-ae1b-b5a0bbb8dd78.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a movie night at our on-site theater, complete with popcorn and comfortable seating.",
      "link": "",
      "alt_text": "Movie theater lobby with posters, popcorn machine, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a775a73f-c3a7-46cd-855b-9845c93a0085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84ed-694f-76cb-9f3a-99744367a5e8.webp",
      "image_media": {
        "alt_text": "Modern fitness center with weight machines, free weights, and a punching bag.",
        "public_id": "019e84ed-694f-76cb-9f3a-99744367a5e8",
        "storage_key": "property/6737460151191772/019e84ed-694f-76cb-9f3a-99744367a5e8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art weight machines, a free weights area, and cardio equipment.",
      "link": "",
      "alt_text": "Modern fitness center with weight machines, free weights, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0eca6bc-04fc-4e62-842b-16f831ee87b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84ed-6759-71b4-88cb-13d82460c021.webp",
      "image_media": {
        "alt_text": "Gym with weights, benches, and exercise balls.",
        "public_id": "019e84ed-6759-71b4-88cb-13d82460c021",
        "storage_key": "property/6737460151191772/019e84ed-6759-71b4-88cb-13d82460c021.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Well-equipped fitness center featuring a variety of weight machines, free weights, benches, and stability balls for a comprehensive workout.",
      "link": "",
      "alt_text": "Gym with weights, benches, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c26989eb-dfa4-4e60-9271-b246986426bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84ed-675a-734a-a3c9-7971b2fdd9ef.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and stationary bikes",
        "public_id": "019e84ed-675a-734a-a3c9-7971b2fdd9ef",
        "storage_key": "property/6737460151191772/019e84ed-675a-734a-a3c9-7971b2fdd9ef.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment like treadmills and stationary bikes.",
      "link": "",
      "alt_text": "Fitness center with treadmills and stationary bikes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc49fdfd-23a0-4902-b38f-03acac26e8a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-f897-76cf-8e3e-006ad78aab11.webp",
      "image_media": {
        "alt_text": "Aerial view of two large swimming pools and courtyards within a multifamily property.",
        "public_id": "019e84eb-f897-76cf-8e3e-006ad78aab11",
        "storage_key": "property/6737460151191772/019e84eb-f897-76cf-8e3e-006ad78aab11.webp",
        "width": 2501,
        "height": 3072
      },
      "title": "Community",
      "description": "Experience resort-style living with two expansive swimming pools and beautifully landscaped courtyards, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Aerial view of two large swimming pools and courtyards within a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80fc4fd0-bab9-44f6-98a9-0a6278749514",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-fa79-706e-8b4d-1c3712407719.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a paved driveway and parked cars.",
        "public_id": "019e84eb-fa79-706e-8b4d-1c3712407719",
        "storage_key": "property/6737460151191772/019e84eb-fa79-706e-8b4d-1c3712407719.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building with balconies and manicured landscaping. A paved driveway leads to a covered entrance, with several cars parked nearby.",
      "link": "",
      "alt_text": "Apartment building exterior with a paved driveway and parked cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_270b7dc9-9a01-4352-ac43-cfb9523bc06b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-ab4c-77e8-9a04-b403f59c51ba.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and courtyard with palm trees and apartment buildings.",
        "public_id": "019e84eb-ab4c-77e8-9a04-b403f59c51ba",
        "storage_key": "property/6737460151191772/019e84eb-ab4c-77e8-9a04-b403f59c51ba.webp",
        "width": 816,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool, complete with fountains and lush landscaping, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Resort-style swimming pool and courtyard with palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5399e6be-daca-4137-97fe-3ed239696957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-aaf7-736a-b4d4-b7ad6732651c.webp",
      "image_media": {
        "alt_text": "View looking up at buildings and palm trees against a blue sky",
        "public_id": "019e84eb-aaf7-736a-b4d4-b7ad6732651c",
        "storage_key": "property/6737460151191772/019e84eb-aaf7-736a-b4d4-b7ad6732651c.webp",
        "width": 1080,
        "height": 719
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with palm trees and a bright blue sky.",
      "link": "",
      "alt_text": "View looking up at buildings and palm trees against a blue sky",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8f8d856-0eea-487d-9c65-5e3341a0a1b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-aad7-71ae-a226-5ea061b9941e.webp",
      "image_media": {
        "alt_text": "Modern apartment complex courtyard with a swimming pool and palm trees at dusk.",
        "public_id": "019e84eb-aad7-71ae-a226-5ea061b9941e",
        "storage_key": "property/6737460151191772/019e84eb-aad7-71ae-a226-5ea061b9941e.webp",
        "width": 755,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in the resort-style swimming pool, surrounded by lush landscaping and modern architecture. A perfect oasis for our residents.",
      "link": "",
      "alt_text": "Modern apartment complex courtyard with a swimming pool and palm trees at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0dbd46b-3226-4ec3-b1bf-52c898463504",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-a94c-7044-a64e-6fb54fa58f6b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "019e84eb-a94c-7044-a64e-6fb54fa58f6b",
        "storage_key": "property/6737460151191772/019e84eb-a94c-7044-a64e-6fb54fa58f6b.webp",
        "width": 1080,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_102af89d-cd75-4379-a044-8cd025ed2f08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-9cdb-761d-89ab-8cd6e3212959.webp",
      "image_media": {
        "alt_text": "Courtyard with pool and lounge chairs.",
        "public_id": "019e84eb-9cdb-761d-89ab-8cd6e3212959",
        "storage_key": "property/6737460151191772/019e84eb-9cdb-761d-89ab-8cd6e3212959.webp",
        "width": 1080,
        "height": 722
      },
      "title": "Community",
      "description": "Relax by the outdoor swimming pool and enjoy the courtyard amenities.",
      "link": "",
      "alt_text": "Courtyard with pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29e9fbb1-2ae6-4202-9502-e02632a09330",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-9d73-717b-a5ba-451ad4c06de3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and fountains.",
        "public_id": "019e84eb-9d73-717b-a5ba-451ad4c06de3",
        "storage_key": "property/6737460151191772/019e84eb-9d73-717b-a5ba-451ad4c06de3.webp",
        "width": 1080,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our beautiful resort-style swimming pool, complete with comfortable lounge chairs and refreshing fountains.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and fountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62b3e55b-c8e5-4e0e-a84c-02d06090d0af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e84eb-9d11-71ee-9a85-b87161ec8233.webp",
      "image_media": {
        "alt_text": "Courtyard swimming pool with fountains and palm trees, surrounded by apartment buildings.",
        "public_id": "019e84eb-9d11-71ee-9a85-b87161ec8233",
        "storage_key": "property/6737460151191772/019e84eb-9d11-71ee-9a85-b87161ec8233.webp",
        "width": 1080,
        "height": 719
      },
      "title": "Community",
      "description": "Relax by the beautiful outdoor swimming pool, complete with fountains and lush palm trees. Enjoy the resort-style amenities at our apartment community.",
      "link": "",
      "alt_text": "Courtyard swimming pool with fountains and palm trees, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f389c7fb-31d4-48fd-86dd-e4fb6c39721d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-ad31-744b-bc12-1e8ca00f3969.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating area.",
        "public_id": "019d076e-ad31-744b-bc12-1e8ca00f3969",
        "storage_key": "property/6737460151191772/019d076e-ad31-744b-bc12-1e8ca00f3969.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay productive in our modern business center, equipped with computers, printing services, and comfortable seating for all your work needs.",
      "link": "",
      "alt_text": "Business center with computers, printer, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92ab517c-5636-4397-b799-f49d11144f51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076e-abcc-759f-84fd-16db1ed2989e.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment",
        "public_id": "019d076e-abcc-759f-84fd-16db1ed2989e",
        "storage_key": "property/6737460151191772/019d076e-abcc-759f-84fd-16db1ed2989e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide range of weight machines and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym with weight machines and cardio equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0bb77890-9957-43cb-a93d-e11388baf0f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Rudi Lechner's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2503 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Traditional German go-to with a Wednesday night buffet, country-style cooking & live polka music.",
      "poi_long_description": "Traditional German go-to with a Wednesday night buffet, country-style cooking & live polka music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-76ac-753e-847e-af0233c4b417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-76ac-753e-847e-af0233c4b417",
        "storage_key": "property/6737460151191772/019e1e1d-76ac-753e-847e-af0233c4b417.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rudilechners.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10330467442646526326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rudi-lechners-restaurant",
      "poi_latitude": "29.7403855",
      "poi_longitude": "-95.5378842",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-782-1180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQtmABXDQIYRdimv6mcxXY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_cc7fb151-e340-4c85-a164-59723b5c25d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "El Tiempo Cantina",
      "poi_type": "Restaurants",
      "poi_address": "2605 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Lively branch of a family-run cantina chain known for its margaritas & hearty Tex-Mex dishes.",
      "poi_long_description": "Lively branch of a family-run cantina chain known for its margaritas & hearty Tex-Mex dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-714c-72ba-a719-9036bcd6c867.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-714c-72ba-a719-9036bcd6c867",
        "storage_key": "property/6737460151191772/019e1e1d-714c-72ba-a719-9036bcd6c867.webp",
        "width": 1280,
        "height": 825
      },
      "poi_business_url": "https://www.eltiempocantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14120437307440120738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tiempo-cantina",
      "poi_latitude": "29.7392088",
      "poi_longitude": "-95.5379199",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 713-785-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWzuyBXDQIYRokMk9-re9cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ad7be1ef-a360-4cc3-bd85-5f07c4fcf6de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Saigon Gessner Noodle & Rice",
      "poi_type": "Restaurants",
      "poi_address": "2553 Gessner Rd, Houston, TX 77080, USA",
      "poi_short_description": "Informal eatery serving a variety of beef noodle soups (pho) & other classic Vietnamese fare.",
      "poi_long_description": "Informal eatery serving a variety of beef noodle soups (pho) & other classic Vietnamese fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-6e8e-705a-8b17-fa5feb27b4b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-6e8e-705a-8b17-fa5feb27b4b5",
        "storage_key": "property/6737460151191772/019e1e1d-6e8e-705a-8b17-fa5feb27b4b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575953775402967262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saigon-gessner-noodle--rice",
      "poi_latitude": "29.818542",
      "poi_longitude": "-95.546111",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-329-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRWq-iPFQIYR3mDkgmrEYU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_95b5f0c0-cfa7-456d-a4cd-f5711349f278",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Kofoshi",
      "poi_type": "Restaurants",
      "poi_address": "3706 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-7b56-73dd-9a2e-be6cdf063206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-7b56-73dd-9a2e-be6cdf063206",
        "storage_key": "property/6737460151191772/019e1e1d-7b56-73dd-9a2e-be6cdf063206.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11195510198941802686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kofoshi",
      "poi_latitude": "29.7240514",
      "poi_longitude": "-95.5397243",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 346-252-2336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiXz1L7jDQIYRvmAwpzVxXps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b3ab6e09-1b4f-440d-bc7e-6267a53394b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "La Tapatia",
      "poi_type": "Restaurants",
      "poi_address": "3820 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Laid-back cantina serving Tex-Mex favorites from breakfast until late at night.",
      "poi_long_description": "Laid-back cantina serving Tex-Mex favorites from breakfast until late at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-740e-73a7-a0fe-57d1f13d76d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-740e-73a7-a0fe-57d1f13d76d9",
        "storage_key": "property/6737460151191772/019e1e1d-740e-73a7-a0fe-57d1f13d76d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://latapatia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9360915586817414094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tapatia",
      "poi_latitude": "29.7221445",
      "poi_longitude": "-95.5404445",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-266-4756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpePepR_DQIYRzlOrRCGn6IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8eb5e1a4-2d06-49a6-bba0-af9225ac5071",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "South x Saigon",
      "poi_type": "Restaurants",
      "poi_address": "3991 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Relaxed restaurant serving up a mix of Vietnamese, Cajun, and Texan recipes, such as crawfish.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-74d9-71ff-b108-212bed13b446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-74d9-71ff-b108-212bed13b446",
        "storage_key": "property/6737460151191772/019e1e1d-74d9-71ff-b108-212bed13b446.webp",
        "width": 1280,
        "height": 944
      },
      "poi_business_url": "https://www.southbysaigon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=532583407272822679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-x-saigon",
      "poi_latitude": "29.7222749",
      "poi_longitude": "-95.5380032",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-781-1788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5Z43_PDQIYRl4fDg8kdZAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_36d99e3e-8012-4fa9-af8e-751fb7152268",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "State Fare Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "947 Gessner Rd Ste B 190, Houston, TX 77024, USA",
      "poi_short_description": "Homestyle Southern cuisine including burgers & gumbo served in a relaxed space with funky flair.",
      "poi_long_description": "Homestyle Southern cuisine including burgers & gumbo served in a relaxed space with funky flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-7456-74cf-b73a-0440e5f197c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-7456-74cf-b73a-0440e5f197c5",
        "storage_key": "property/6737460151191772/019e1e1d-7456-74cf-b73a-0440e5f197c5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.statefaretx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11526826477548385717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-fare-kitchen--bar",
      "poi_latitude": "29.78357339999999",
      "poi_longitude": "-95.5457565",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-831-0950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzFrr77EQIYRtbXWDZyD958",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_597a24cb-5585-4870-a2cf-e7d28c49bb42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Churrascos Memorial City",
      "poi_type": "Restaurants",
      "poi_address": "947 Gessner Rd Suite B-290, Houston, TX 77024, USA",
      "poi_short_description": "Branch of a popular, Pan-Latin chain offering steaks, seafood & tres leches cake.",
      "poi_long_description": "Branch of a popular, Pan-Latin chain offering steaks, seafood & tres leches cake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-78ab-71cf-9442-fb2b998e0ae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-78ab-71cf-9442-fb2b998e0ae4",
        "storage_key": "property/6737460151191772/019e1e1d-78ab-71cf-9442-fb2b998e0ae4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.churrascos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6130938790918404102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "churrascos-memorial-city",
      "poi_latitude": "29.7834907",
      "poi_longitude": "-95.5458076",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-231-1352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQr7rb7EQIYRBrha5Fh4FVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_44661a7b-f965-4297-96c6-4485d7186903",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "600 Memorial City Mall, Houston, TX 77024, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-7c7c-725c-b17b-db6e56ae02a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-7c7c-725c-b17b-db6e56ae02a2",
        "storage_key": "property/6737460151191772/019e1e1d-7c7c-725c-b17b-db6e56ae02a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/tx/houston-153.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10479089012998838806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "29.7815731",
      "poi_longitude": "-95.5429032",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-932-6344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZXU7bzEQIYRFpp-ze8zbZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1820aa62-f3fd-441c-86ef-0b9c7b54fd93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Roostar",
      "poi_type": "Restaurants",
      "poi_address": "1411 Gessner Rd Suite I, Houston, TX 77080, USA",
      "poi_short_description": "This counter-serve eatery offers Vietnamese banh mi sandwiches, rice & noodle dishes & wings.",
      "poi_long_description": "This counter-serve eatery offers Vietnamese banh mi sandwiches, rice & noodle dishes & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-7d57-713b-a84f-f7240cd44a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-7d57-713b-a84f-f7240cd44a00",
        "storage_key": "property/6737460151191772/019e1e1d-7d57-713b-a84f-f7240cd44a00.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "http://www.myroostar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9960800549861682895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roostar",
      "poi_latitude": "29.7956781",
      "poi_longitude": "-95.545122",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-649-8955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2-m78PEQIYRz24FVVPfO4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_a72d4218-7362-46b1-b7f6-9298ceb6c501",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Pho Zen Texas",
      "poi_type": "Restaurants",
      "poi_address": "2674 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Bright, family-owned spot with a casual vibe & menu of Vietnamese classics like soup & rice plates.",
      "poi_long_description": "Bright, family-owned spot with a casual vibe & menu of Vietnamese classics like soup & rice plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-701b-718d-ae90-4b116940b2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-701b-718d-ae90-4b116940b2b2",
        "storage_key": "property/6737460151191772/019e1e1d-701b-718d-ae90-4b116940b2b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15874599368997810371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-zen-texas",
      "poi_latitude": "29.73765389999999",
      "poi_longitude": "-95.5393315",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 346-701-7181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfsv2xXDQIYRwzDB1AToTdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_0d3a36e3-3074-4536-823f-96631cc31b5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Randalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "9660 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Grocery store chain supplying produce, baked goods, meats, and other essentials, plus a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8055-7727-bc3a-86780d8561e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8055-7727-bc3a-86780d8561e3",
        "storage_key": "property/6737460151191772/019e1e1d-8055-7727-bc3a-86780d8561e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.randalls.com/tx/houston/9660-westheimer-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12171927843379335079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randalls",
      "poi_latitude": "29.7387246",
      "poi_longitude": "-95.5369829",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-782-0982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8fb-7679-a5ef-d17f31220e0a",
        "storage_key": "property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZM9JhTDQIYRp89PSOJf66g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ea01d5a5-3c86-402a-adec-01e0aa0405ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9525 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-80cf-76b8-ad2c-62c6c6cecbab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-80cf-76b8-ad2c-62c6c6cecbab",
        "storage_key": "property/6737460151191772/019e1e1d-80cf-76b8-ad2c-62c6c6cecbab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/houston/9525-westheimer/fa94",
      "poi_directions_map_url": "https://maps.google.com/?cid=10789530273526308404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "29.7361",
      "poi_longitude": "-95.5337",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8fb-7679-a5ef-d17f31220e0a",
        "storage_key": "property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZRyRTHDQIYRNN7bTp4cvJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1e8e037e-6d21-4f45-b841-b3ec3ac448c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Gessner Rd, Houston, TX 77080, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-80e7-74ea-b386-54573a2b47cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-80e7-74ea-b386-54573a2b47cc",
        "storage_key": "property/6737460151191772/019e1e1d-80e7-74ea-b386-54573a2b47cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/hammerly-plaza/034/00607?cid=loc_03400607_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107502496519259230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.8140618",
      "poi_longitude": "-95.5440107",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-467-9343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8fb-7679-a5ef-d17f31220e0a",
        "storage_key": "property/6737460151191772/019e1e1b-d8fb-7679-a5ef-d17f31220e0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxnV4CDFQIYRXoTjHKejXg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_951db5c8-1191-4a5b-ae29-104dcf43fceb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2727 Dunvale Rd, Houston, TX 77063, USA",
      "poi_short_description": "Department store chain selling merchandise ranging from clothes and groceries to electronics and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-80e1-7348-8048-63e5fd65d8f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-80e1-7348-8048-63e5fd65d8f7",
        "storage_key": "property/6737460151191772/019e1e1d-80e1-7348-8048-63e5fd65d8f7.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2066-houston-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3480070244548764473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.7355775",
      "poi_longitude": "-95.5115421",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-977-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0Sq1_qTDQIYROWO8_3KxSzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_16f5a580-d7da-442a-9813-44e3a6d6ef4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8605 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-82de-744d-9aad-003e3ce43e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-82de-744d-9aad-003e3ce43e55",
        "storage_key": "property/6737460151191772/019e1e1d-82de-744d-9aad-003e3ce43e55.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "https://www.target.com/sl/westheimer/2139",
      "poi_directions_map_url": "https://maps.google.com/?cid=9203089853747331372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.7349092",
      "poi_longitude": "-95.5176251",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-331-0373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm81dgT7DQIYRLIGcQHbxt38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4eae887e-0efe-4a3b-8fc6-6c6d58239ca1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8605 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8626-71e4-afaa-980db6fbd14f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8626-71e4-afaa-980db6fbd14f",
        "storage_key": "property/6737460151191772/019e1e1d-8626-71e4-afaa-980db6fbd14f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/8605-westheimer-rd-houston-tx-77063/storeid=17222?WT.mc_id=LS_GOOGLE_RX_17222",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371479526294028657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.734788",
      "poi_longitude": "-95.5176225",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-331-0374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7b5-722f-89bb-8e3789611cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7b5-722f-89bb-8e3789611cb1",
        "storage_key": "property/6737460151191772/019e1e1d-c7b5-722f-89bb-8e3789611cb1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm81dgT7DQIYRcQG6U5fkE_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f96b8367-7b1c-4e79-bbcb-c3fbf4049e6a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "9600 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-86b7-70b2-9c75-7ad48098c09f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-86b7-70b2-9c75-7ad48098c09f",
        "storage_key": "property/6737460151191772/019e1e1d-86b7-70b2-9c75-7ad48098c09f.webp",
        "width": 1280,
        "height": 723
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9600+westheimer+rd-houston-tx-77063/id=6484",
      "poi_directions_map_url": "https://maps.google.com/?cid=6872805041320056205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7381341",
      "poi_longitude": "-95.5355254",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-952-9916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaet9xPDQIYRjVVlesUbYV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_72e40f8e-4c45-4f55-96e6-5f04c8c03434",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "3770 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "Gas station and convenience store offering prepared foods, snacks, and beverages, plus an ATM.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8790-7168-a05b-06075a81534b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8790-7168-a05b-06075a81534b",
        "storage_key": "property/6737460151191772/019e1e1d-8790-7168-a05b-06075a81534b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/houston/3770-s-gessner-rd/2742166?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13186183060088574603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.7227695",
      "poi_longitude": "-95.53978870000002",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-783-6045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c78a-7098-b341-3fc6c941bfd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c78a-7098-b341-3fc6c941bfd6",
        "storage_key": "property/6737460151191772/019e1e1d-c78a-7098-b341-3fc6c941bfd6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ5bauwRjDQIYRi1LaN6G7_rY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_3550194e-22cd-44b3-9408-f6c32c9a00d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "9523 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8a5e-756a-b2c6-0d5c0112eaf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8a5e-756a-b2c6-0d5c0112eaf7",
        "storage_key": "property/6737460151191772/019e1e1d-8a5e-756a-b2c6-0d5c0112eaf7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/houston/9523-westheimer-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6627696101610933153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.7361337",
      "poi_longitude": "-95.5331773",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 346-613-6987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE3QEfxHDQIYRocvCR31O-ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0f1cb3ef-717e-4018-8b70-ab333b3568ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8400 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8a5e-756a-b2c6-0831c31b3836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8a5e-756a-b2c6-0831c31b3836",
        "storage_key": "property/6737460151191772/019e1e1d-8a5e-756a-b2c6-0831c31b3836.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Westheimer/TX/Houston/77063/6558?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11683003218252590386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "29.7396486",
      "poi_longitude": "-95.5151407",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-917-0510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ8oaXqHDQIYRMu2wHYddIqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3131b097-3383-4e9c-82d3-37795135b0fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Emerson Elementary School",
      "poi_type": "Education",
      "poi_address": "9533 Skyline Dr, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8d48-726e-bd5c-6549d0402025.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8d48-726e-bd5c-6549d0402025",
        "storage_key": "property/6737460151191772/019e1e1d-8d48-726e-bd5c-6549d0402025.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://houstonisd.org/EmersonES",
      "poi_directions_map_url": "https://maps.google.com/?cid=10005088103532882258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerson-elementary-school",
      "poi_latitude": "29.7264666",
      "poi_longitude": "-95.5342926",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-917-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPQY0khvDQIYRUmmQ9Z422Yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fb4593d5-56a7-4474-a580-4fd69dae6553",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Paul Revere Middle School",
      "poi_type": "Education",
      "poi_address": "10502 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8bbe-72fb-bdd7-9bbf46c1220d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8bbe-72fb-bdd7-9bbf46c1220d",
        "storage_key": "property/6737460151191772/019e1e1d-8bbe-72fb-bdd7-9bbf46c1220d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15293944486870122678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-revere-middle-school",
      "poi_latitude": "29.7486547",
      "poi_longitude": "-95.5608907",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-917-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiTDco0zDQIYRtgBw4noBP9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d59cecd9-9b16-48f6-b57d-7fe5d5dab142",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westside High School",
      "poi_type": "Education",
      "poi_address": "14201 Briar Forest Dr, Houston, TX 77077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8f09-7327-90cf-da3936165d8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8f09-7327-90cf-da3936165d8c",
        "storage_key": "property/6737460151191772/019e1e1d-8f09-7327-90cf-da3936165d8c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.houstonisd.org/westsidehs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5117399222305862051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westside-high-school",
      "poi_latitude": "29.7545326",
      "poi_longitude": "-95.6375044",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-920-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dp5FAXcQIYRo7Fmw3qnBEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_722e9be5-de99-44ff-9c3a-e5565a1dfc53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Piney Point Elementary School",
      "poi_type": "Education",
      "poi_address": "8921 Pagewood Ln, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8c3f-752e-a7d2-fd8bdf90335d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8c3f-752e-a7d2-fd8bdf90335d",
        "storage_key": "property/6737460151191772/019e1e1d-8c3f-752e-a7d2-fd8bdf90335d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.houstonisd.org/Domain/19116",
      "poi_directions_map_url": "https://maps.google.com/?cid=3314358176771680291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piney-point-elementary-school",
      "poi_latitude": "29.7247993",
      "poi_longitude": "-95.5217348",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-917-3610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1TPnwgDDQIYRIyjjmDP3_i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8c698202-ebe9-439f-b5cb-a6e9938bd023",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Sneed Elementary School",
      "poi_type": "Education",
      "poi_address": "9855 Pagewood Ln, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sneed.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18356224938724685907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sneed-elementary-school",
      "poi_latitude": "29.7247712",
      "poi_longitude": "-95.5447465",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-789-6979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV1pReyHDQIYRU_jZiVNpvv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b699f9e4-81dd-4af0-8778-262db3fa8ab0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "KIPP Sharpstown College Preparatory",
      "poi_type": "Education",
      "poi_address": "8440 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kipptexas.org/school/kipp-sharpstown-college-prep/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3194886957032839989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kipp-sharpstown-college-preparatory",
      "poi_latitude": "29.7229489",
      "poi_longitude": "-95.5128814",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-879-3005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNaaj76zDQIYRNZt4m8KEViw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2061d02e-2f85-499c-970d-e02c3f28aa30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "The Tenney School",
      "poi_type": "Education",
      "poi_address": "3500 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8c94-770e-bc86-a3847758902e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8c94-770e-bc86-a3847758902e",
        "storage_key": "property/6737460151191772/019e1e1d-8c94-770e-bc86-a3847758902e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tenneyschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11443279700466152884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tenney-school",
      "poi_latitude": "29.7256924",
      "poi_longitude": "-95.5399622",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-783-6990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ300sshjDQIYRtDW5K0Kyzp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_616a92d0-7987-449d-926f-32dab8efea9f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Panda Bear Academy - Houston, Texas",
      "poi_type": "Education",
      "poi_address": "3416 Fondren Rd, Houston, TX 77063, USA",
      "poi_short_description": "Daycare center providing services including after-school programs and potty training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8dd5-7738-aa74-e895808d0e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8dd5-7738-aa74-e895808d0e65",
        "storage_key": "property/6737460151191772/019e1e1d-8dd5-7738-aa74-e895808d0e65.webp",
        "width": 480,
        "height": 332
      },
      "poi_business_url": "https://pandabearacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15773422417200043841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-bear-academy---houston-texas",
      "poi_latitude": "29.7266291",
      "poi_longitude": "-95.5208998",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-784-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq7HHNgfDQIYRQVdkBR505to",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_47a5f4e5-59d3-4f38-8513-d7d9b3568d08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Kindercity",
      "poi_type": "Education",
      "poi_address": "3750 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9070-72a8-8547-90c940c7677b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9070-72a8-8547-90c940c7677b",
        "storage_key": "property/6737460151191772/019e1e1d-9070-72a8-8547-90c940c7677b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2129239464766652776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindercity",
      "poi_latitude": "29.7232927",
      "poi_longitude": "-95.5394134",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-334-4448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz26fDR_DQIYRaMEoEwOUjB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_935f38bc-4867-44e0-85fb-47194af09532",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westpark Star Kids Academy",
      "poi_type": "Education",
      "poi_address": "3969 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9835028148626979152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westpark-star-kids-academy",
      "poi_latitude": "29.7225377",
      "poi_longitude": "-95.5381145",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-400-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm4yFxh_DQIYRUPngMv4JfYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_253d3161-00ba-4a41-8ef2-7f0b057671f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Cinemark Memorial City",
      "poi_type": "Entertainment",
      "poi_address": "310 Memorial City Mall, Houston, TX 77024, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-8ee9-74df-8554-8e1704596895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-8ee9-74df-8554-8e1704596895",
        "storage_key": "property/6737460151191772/019e1e1d-8ee9-74df-8554-8e1704596895.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-houston/cinemark-memorial-city?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006184974408473747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-memorial-city",
      "poi_latitude": "29.7799092",
      "poi_longitude": "-95.5408135",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-467-9749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7a7-722e-8dac-0452325df388",
        "storage_key": "property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwXHNpfEQIYRk9yjElNAf7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6c53779e-8813-4fc3-9419-1619de2131d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Star Cinema Grill CityCenter",
      "poi_type": "Entertainment",
      "poi_address": "CityCenter, 822 Town and Country Blvd Suite 200, Houston, TX 77024, USA",
      "poi_short_description": "Theatre featuring seat-side service, reclining chairs, heated seats and an expanded menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-92d6-75bc-9b41-84fb525af832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-92d6-75bc-9b41-84fb525af832",
        "storage_key": "property/6737460151191772/019e1e1d-92d6-75bc-9b41-84fb525af832.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/citycentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=5867569438081115187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill-citycenter",
      "poi_latitude": "29.7816296",
      "poi_longitude": "-95.5610211",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-277-7910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7a7-722e-8dac-0452325df388",
        "storage_key": "property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdroU0PFQIYRM2TD81DLbVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9b07521c-d95f-4d28-8330-24e8505faba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "CITYCENTRE",
      "poi_type": "Entertainment",
      "poi_address": "800 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_long_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-926d-70b9-9149-41ae19547406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-926d-70b9-9149-41ae19547406",
        "storage_key": "property/6737460151191772/019e1e1d-926d-70b9-9149-41ae19547406.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.citycentrehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16787131420789938490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citycentre",
      "poi_latitude": "29.7810228",
      "poi_longitude": "-95.5592668",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-463-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ_xOrPEQIYROpn7zRXf9-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a2e6d9f2-e638-476f-8ac2-56926665bc47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Marq-E Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "7620 Katy Fwy, Houston, TX 77024, USA",
      "poi_short_description": "Spacious plaza with an arcade chain, comedy club & movie theater, plus informal restaurant options.",
      "poi_long_description": "Spacious plaza with an arcade chain, comedy club & movie theater, plus informal restaurant options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-95a1-70ca-87aa-5a4453d3f3a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-95a1-70ca-87aa-5a4453d3f3a0",
        "storage_key": "property/6737460151191772/019e1e1d-95a1-70ca-87aa-5a4453d3f3a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.marqehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11015790733734785276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marq-e-entertainment-center",
      "poi_latitude": "29.785747",
      "poi_longitude": "-95.4652313",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-290-1596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7a7-722e-8dac-0452325df388",
        "storage_key": "property/6737460151191772/019e1e1d-c7a7-722e-8dac-0452325df388.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJl841dLvGQIYR_DBN5E7z35g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c9ba9c2a-a5b4-4e04-9869-727bea0f17b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Dave & Buster's Houston - Katy Fwy",
      "poi_type": "Entertainment",
      "poi_address": "7620 Katy Fwy Ste 100, Houston, TX 77024, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-832b-724c-83ca-16d8669be204.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-832b-724c-83ca-16d8669be204",
        "storage_key": "property/6737460151191772/019e1e1b-832b-724c-83ca-16d8669be204.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/houston-katy-fwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6837744502642803136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-houston---katy-fwy",
      "poi_latitude": "29.7862052",
      "poi_longitude": "-95.4659137",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-263-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5s0I7vGQIYRwIHnsGWM5F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ae335836-7f64-404d-8c67-26b73a06b94a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Houston Improv",
      "poi_type": "Entertainment",
      "poi_address": "7620 Katy Fwy #45, Houston, TX 77024, USA",
      "poi_short_description": "Internationally known comedians take center stage at this compact spot also serving food & drinks.",
      "poi_long_description": "Internationally known comedians take center stage at this compact spot also serving food & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-934b-7724-96d2-5f520649a183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-934b-7724-96d2-5f520649a183",
        "storage_key": "property/6737460151191772/019e1e1d-934b-7724-96d2-5f520649a183.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "https://improvtx.com/houston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9673118899161113660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-improv",
      "poi_latitude": "29.7855562",
      "poi_longitude": "-95.4639568",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-333-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5s0I7vGQIYRPKSdbmPSPYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "comedy_club"
    },
    {
      "id": "custom_8222b68d-6fc8-47ec-b1e1-3b21ed932bda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Reveal Lounge",
      "poi_type": "Entertainment",
      "poi_address": "3003 Fondren Rd, Houston, TX 77063, USA",
      "poi_short_description": "Cocktails, bar bites & regular DJ sets are the draw at this cool lounge featuring outdoor seating.",
      "poi_long_description": "Cocktails, bar bites & regular DJ sets are the draw at this cool lounge featuring outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9394-7207-83cc-1374ca904a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9394-7207-83cc-1374ca904a91",
        "storage_key": "property/6737460151191772/019e1e1d-9394-7207-83cc-1374ca904a91.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.revealhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=602362893079892313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reveal-lounge",
      "poi_latitude": "29.7318906",
      "poi_longitude": "-95.5201494",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-380-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7a6-730d-b6d8-15139136e053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7a6-730d-b6d8-15139136e053",
        "storage_key": "property/6737460151191772/019e1e1d-c7a6-730d-b6d8-15139136e053.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bj_8Q7DQIYRWVHnG9wFXAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lounge_bar"
    },
    {
      "id": "custom_58588244-53e9-49cf-8b43-44246a95a58b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "The Galleria",
      "poi_type": "Entertainment",
      "poi_address": "5085 Westheimer Rd, Houston, TX 77056, USA",
      "poi_short_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_long_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-781f-7308-a511-dbd513e88af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-781f-7308-a511-dbd513e88af9",
        "storage_key": "property/6737460151191772/019e1e1b-781f-7308-a511-dbd513e88af9.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.simon.com/mall/the-galleria",
      "poi_directions_map_url": "https://maps.google.com/?cid=9080376292649229487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-galleria",
      "poi_latitude": "29.7391955",
      "poi_longitude": "-95.4634342",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-622-0663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0b3z7m7BQIYRr1w81iD6A34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9b2b2209-5c63-4c87-9c8f-d92c0defbdbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Gerald D. Hines Waterwall Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 Post Oak Blvd, Houston, TX 77056, USA",
      "poi_short_description": "Park whose centerpiece is a 64-ft.-tall fountain circulating 11,000 gallons of water every minute.",
      "poi_long_description": "Park whose centerpiece is a 64-ft.-tall fountain circulating 11,000 gallons of water every minute.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-9c03-7286-82c3-d10a50086d6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-9c03-7286-82c3-d10a50086d6e",
        "storage_key": "property/6737460151191772/019e1e1b-9c03-7286-82c3-d10a50086d6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uptown-houston.com/news/page/water-wall-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17599516903679957705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gerald-d-hines-waterwall-park",
      "poi_latitude": "29.7359479",
      "poi_longitude": "-95.4613024",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-850-8841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTwf6G3BQIYRyZpTrmALPvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_976ad814-eb71-4082-92a3-a97c49bca6e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Topgolf Houston - Katy",
      "poi_type": "Entertainment",
      "poi_address": "1030 Memorial Brook Blvd, Houston, TX 77084, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9b7b-76cb-ba54-f0b863d85c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9b7b-76cb-ba54-f0b863d85c4e",
        "storage_key": "property/6737460151191772/019e1e1d-9b7b-76cb-ba54-f0b863d85c4e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/houston-west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763942538676567838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-houston---katy",
      "poi_latitude": "29.7867434",
      "poi_longitude": "-95.6500505",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-406-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d841-76f8-8d45-d2cc7f2dd286",
        "storage_key": "property/6737460151191772/019e1e1b-d841-76f8-8d45-d2cc7f2dd286.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW-E02bZQIYRHn_sL2nrQaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c1fdaf3a-a340-4293-9bf3-08abbda6b37e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Memorial Hermann Southwest Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 Beechnut St, Houston, TX 77074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-9823-76fc-8196-825519763a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-9823-76fc-8196-825519763a6d",
        "storage_key": "property/6737460151191772/019e1e1b-9823-76fc-8196-825519763a6d.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/southwest?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615674855845486349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-southwest-hospital",
      "poi_latitude": "29.692891",
      "poi_longitude": "-95.5212694",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-456-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8bf-7796-84e0-8518c658398b",
        "storage_key": "property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aSzG4zCQIYRDV9fldMrDkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_83f9b0c0-c12f-4786-a585-64d5374fecfa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Memorial Hermann Memorial City Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "921 Gessner Rd, Houston, TX 77024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-98c9-707a-bf4a-fa4ccf58ac84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-98c9-707a-bf4a-fa4ccf58ac84",
        "storage_key": "property/6737460151191772/019e1e1d-98c9-707a-bf4a-fa4ccf58ac84.webp",
        "width": 1004,
        "height": 1280
      },
      "poi_business_url": "https://memorialhermann.org/locations/memorial-city?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341386861309126237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-memorial-city-medical-center",
      "poi_latitude": "29.7815046",
      "poi_longitude": "-95.5465014",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-242-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8bf-7796-84e0-8518c658398b",
        "storage_key": "property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQQlc7zEQIYRXeYMO3TY4WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_fc04b742-3891-41ea-a9dd-d0f8f87aa095",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Dunvale Rd",
      "poi_type": "Health and Wellness",
      "poi_address": "2727 Dunvale Rd unit d, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-98d6-7408-9bcb-39e7e867b6ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-98d6-7408-9bcb-39e7e867b6ed",
        "storage_key": "property/6737460151191772/019e1e1d-98d6-7408-9bcb-39e7e867b6ed.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.carenow.com/locations/houston/dunvale-rd?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7270164257874735124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---dunvale-rd",
      "poi_latitude": "29.7354809",
      "poi_longitude": "-95.5122176",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-830-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0P3Ug3DQIYRFHBdod_P5GQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_45de91f9-e0ee-4ce2-baa1-37fa872a24c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2727 Dunvale Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-990b-72a7-84ff-465a1225dc66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-990b-72a7-84ff-465a1225dc66",
        "storage_key": "property/6737460151191772/019e1e1d-990b-72a7-84ff-465a1225dc66.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/2066-houston-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14935148434153776368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "29.7355775",
      "poi_longitude": "-95.5115421",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-977-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7b5-722f-89bb-8e3789611cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7b5-722f-89bb-8e3789611cb1",
        "storage_key": "property/6737460151191772/019e1e1d-c7b5-722f-89bb-8e3789611cb1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Wgn-aTDQIYR8KR3_V5ORM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5af30b03-c61f-47a8-8444-97cf0fb2fca0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9603 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Clean fitness center with a pool, basketball courts and a sauna, plus strength classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-9a24-73fa-a4ef-d7d3a1bdfc93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-9a24-73fa-a4ef-d7d3a1bdfc93",
        "storage_key": "property/6737460151191772/019e1e1b-9a24-73fa-a4ef-d7d3a1bdfc93.webp",
        "width": 1280,
        "height": 883
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=674&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1923095509877188466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.7362567",
      "poi_longitude": "-95.5363836",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-470-4098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVS8gxbDQIYRcudgXy01sBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eede8aa7-ab62-4d72-9286-934b5190c37b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Pro Physique Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9660 Westheimer Rd #500, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://fs23.formsite.com/prophysique/impact/secure_index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14553764310854923097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pro-physique-fitness",
      "poi_latitude": "29.7385798",
      "poi_longitude": "-95.5356486",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-651-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xrSdBTDQIYRWfNDFYhb-ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_031aeb4f-7707-4edc-92ff-4d70a205f3a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Pilates Plus",
      "poi_type": "Health and Wellness",
      "poi_address": "7700 San Felipe St #165, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9bbb-7041-a720-4122dcd2208f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9bbb-7041-a720-4122dcd2208f",
        "storage_key": "property/6737460151191772/019e1e1d-9bbb-7041-a720-4122dcd2208f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8442678528357133179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-plus",
      "poi_latitude": "29.7513045",
      "poi_longitude": "-95.5043753",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-249-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZxXoXZHDQIYRe2uL62NrKnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4818020f-f261-4c9f-aced-41246c3d7c75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Lumiere Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "2950 S Gessner Rd Suite#208, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14943671695350543484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lumiere-spa",
      "poi_latitude": "29.7341216",
      "poi_longitude": "-95.5399918",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-977-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJayDd3BfDQIYRfLRtYTuWYs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "custom_d02bd917-c288-409f-8128-507dc635086e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "RDX Sports",
      "poi_type": "Health and Wellness",
      "poi_address": "8280 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9b19-77f1-94fe-d177802b7ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9b19-77f1-94fe-d177802b7ecc",
        "storage_key": "property/6737460151191772/019e1e1d-9b19-77f1-94fe-d177802b7ecc.webp",
        "width": 300,
        "height": 300
      },
      "poi_business_url": "https://rdxsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11011358383177641654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rdx-sports",
      "poi_latitude": "29.72250979999999",
      "poi_longitude": "-95.5104143",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-739-8326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8a2-753d-a0b0-3ec40181b8e1",
        "storage_key": "property/6737460151191772/019e1e1b-d8a2-753d-a0b0-3ec40181b8e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDSk9a63DQIYRtq7S2xs00Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_99156a94-f9c2-47cc-bd17-068ab160ca7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Woodchase Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 Woodchase Dr, Houston, TX 77042, USA",
      "poi_short_description": "Opened in late October 2021, this family-friendly park in Westchase features a children's playground, a water misting feature, and a community garden. There's also a dog park, a fitness space, and a 2,700-square-foot multi-purpose pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9d12-72ee-8b8c-777263c29d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9d12-72ee-8b8c-777263c29d07",
        "storage_key": "property/6737460151191772/019e1e1d-9d12-72ee-8b8c-777263c29d07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodchasepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614271494229080655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodchase-park",
      "poi_latitude": "29.7205792",
      "poi_longitude": "-95.5438708",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-615-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbjA84zDQIYRTzp4kmMuLqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a0049358-57b8-4c4e-b6bc-ac1ee456f773",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Camden Park Westchase",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2951 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Popular park featuring a splash pad, dog parks and a playground for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a00d-76e8-9b47-74b2a0b53c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-a00d-76e8-9b47-74b2a0b53c54",
        "storage_key": "property/6737460151191772/019e1e1b-a00d-76e8-9b47-74b2a0b53c54.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://camdenparkwestchase.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949308463253431202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-park-westchase",
      "poi_latitude": "29.729676",
      "poi_longitude": "-95.5707528",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-780-9434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVhvDqDdQIYRoiM6Gu6dUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9f273cc6-f50e-426a-80ad-6d131eb1ed6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Home2 Suites by Hilton Houston Westchase",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3125 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Casual all-suite hotel offering free breakfast, Wi-Fi & parking, plus an outdoor pool & BBQ grills.",
      "poi_long_description": "Casual all-suite hotel offering free breakfast, Wi-Fi & parking, plus an outdoor pool & BBQ grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9ee7-714a-88cd-110f4d86a926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9ee7-714a-88cd-110f4d86a926",
        "storage_key": "property/6737460151191772/019e1e1d-9ee7-714a-88cd-110f4d86a926.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "https://www.hilton.com/en/hotels/houspht-home2-suites-houston-westchase/?SEO_id=GMB-AMER-HT-HOUSPHT&y_source=1_MTIyMDc5NjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7277340295047069732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "home2-suites-by-hilton-houston-westchase",
      "poi_latitude": "29.7306839",
      "poi_longitude": "-95.5710796",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 832-295-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7a8-7012-8e13-862f5c19e27f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7a8-7012-8e13-862f5c19e27f",
        "storage_key": "property/6737460151191772/019e1e1d-c7a8-7012-8e13-862f5c19e27f.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJE6qeHPDdQIYRJMDq-3BO_mQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_330cd87e-14b2-411c-8805-797847e46034",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Brays Bayou Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9601 Braes Bayou Dr, Houston, TX 77074, USA",
      "poi_short_description": "Paved hiking & biking greenway trail that winds along the bayou, passing by city parks.",
      "poi_long_description": "Paved hiking & biking greenway trail that winds along the bayou, passing by city parks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-9e76-7245-87b6-1bfa28a061d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-9e76-7245-87b6-1bfa28a061d1",
        "storage_key": "property/6737460151191772/019e1e1d-9e76-7245-87b6-1bfa28a061d1.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.pct3.hctx.net/parks/braysbayouhikebike.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14181295506789459495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brays-bayou-park",
      "poi_latitude": "29.7084257",
      "poi_longitude": "-95.3857579",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 281-496-2177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eBLWwDCQIYRJ2YHsSAVzsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_377aecb6-5601-4a81-bf2d-30d35cb0eaef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Edith L Moore Nature Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "440 Wilchester Blvd, Houston, TX 77079, USA",
      "poi_short_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_long_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a4d1-731b-8dcf-354ee750e7ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a4d1-731b-8dcf-354ee750e7ce",
        "storage_key": "property/6737460151191772/019e1e1d-a4d1-731b-8dcf-354ee750e7ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://houstonaudubon.org/conservation/sanctuaries/edith-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787825092045602411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edith-l-moore-nature-sanctuary",
      "poi_latitude": "29.7706834",
      "poi_longitude": "-95.5683116",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-932-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9XyNFHbQIYRa36wOtoOkTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_53f2dd0c-4609-4ac0-8984-a29905894e18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Bonham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8401 Braes River Dr, Houston, TX 77074, USA",
      "poi_short_description": "Simple park featuring a playground with swings and slides, plus tennis courts and athletic fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a52c-746d-b9d4-b5d69e36f471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a52c-746d-b9d4-b5d69e36f471",
        "storage_key": "property/6737460151191772/019e1e1d-a52c-746d-b9d4-b5d69e36f471.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.houstontx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18342337148486161261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonham-park",
      "poi_latitude": "29.687734",
      "poi_longitude": "-95.5211175",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfKWR4jCQIYRbRP4ZXQSjf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d8cac54e-eee8-4afb-93ee-707fdab9ce31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Club Creek Basin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "MFH3+XG, Houston, TX 77036, USA",
      "poi_short_description": "City park offering a playground and space for activities like walking, running, and hiking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a51c-7252-b3cd-215cde89f6bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a51c-7252-b3cd-215cde89f6bd",
        "storage_key": "property/6737460151191772/019e1e1d-a51c-7252-b3cd-215cde89f6bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12203362145743246448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-creek-basin-park",
      "poi_latitude": "29.6799497",
      "poi_longitude": "-95.5461994",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2BuxKrDQIYRcJR5IjcNW6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1e93dc8f-a9e9-4d9c-af6f-8e77ff412cf0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Sharpstown Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 Harbor Town Dr Suite A, Houston, TX 77036, USA",
      "poi_short_description": "This 18-hole golf course features a cafe, a pro shop & a practice area with a driving cage.",
      "poi_long_description": "This 18-hole golf course features a cafe, a pro shop & a practice area with a driving cage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a47d-7336-a7d7-1547a328ced8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a47d-7336-a7d7-1547a328ced8",
        "storage_key": "property/6737460151191772/019e1e1d-a47d-7336-a7d7-1547a328ced8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.memorialparkgolf.com/sharpstown-park-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=7579426804214343554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharpstown-park-golf-course",
      "poi_latitude": "29.7062657",
      "poi_longitude": "-95.5307002",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-988-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7f5-771a-8c8a-06a117e24194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7f5-771a-8c8a-06a117e24194",
        "storage_key": "property/6737460151191772/019e1e1d-c7f5-771a-8c8a-06a117e24194.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS-ayPrCQIYRgidFWoWIL2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f8abef5d-a161-4b39-984c-067fed70a9b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Blossom Heights Child Development Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8702 Lipan Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a415-745e-9aea-20855bc0bbf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a415-745e-9aea-20855bc0bbf8",
        "storage_key": "property/6737460151191772/019e1e1d-a415-745e-9aea-20855bc0bbf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://blossomheights.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2370481402851775596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blossom-heights-child-development-center",
      "poi_latitude": "29.7241239",
      "poi_longitude": "-95.5169964",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-780-8702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUe57ravDQIYRbFSmy0ak5SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_9527fff2-65f4-46a5-b3e2-80152474c786",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Braeburn Glen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9510 S Gessner Rd, Houston, TX 77074, USA",
      "poi_short_description": "Small green space along the Brays Bayou Greenway Trail, with a playground & tennis center.",
      "poi_long_description": "Small green space along the Brays Bayou Greenway Trail, with a playground & tennis center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-a8c0-769b-b729-e289480b05ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-a8c0-769b-b729-e289480b05ff",
        "storage_key": "property/6737460151191772/019e1e1d-a8c0-769b-b729-e289480b05ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7145609020479816024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "braeburn-glen-park",
      "poi_latitude": "29.6785133",
      "poi_longitude": "-95.5299058",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 832-395-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d893-7704-b56f-d5797c3a47f1",
        "storage_key": "property/6737460151191772/019e1e1b-d893-7704-b56f-d5797c3a47f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO7R1NoPCQIYRWMGGiYtNKmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d0204478-78f8-48f4-a06d-c200d674e7d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Gessner Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9925 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-ab21-726a-9d55-c1dcce5cfa9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-ab21-726a-9d55-c1dcce5cfa9f",
        "storage_key": "property/6737460151191772/019e1e1d-ab21-726a-9d55-c1dcce5cfa9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8759854959400057547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gessner-park-and-ride",
      "poi_latitude": "29.72044959999999",
      "poi_longitude": "-95.5374292",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7f7-7039-9ac9-d3d2b5208327",
        "storage_key": "property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfhzB_DQIYRy_r7gqxBkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_a0a1aee2-c816-4828-896e-dd3e1ceb56c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westpark/Lower Uptown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5105 Westpark Dr, Houston, TX 77056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-aafa-76fe-b962-7340852b4db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-aafa-76fe-b962-7340852b4db9",
        "storage_key": "property/6737460151191772/019e1e1d-aafa-76fe-b962-7340852b4db9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2350213791813892094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westparklower-uptown-transit-center",
      "poi_latitude": "29.72532499999999",
      "poi_longitude": "-95.4650342",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7f7-7039-9ac9-d3d2b5208327",
        "storage_key": "property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUi1hV3BQIYR_ndK3_2inSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_87c919fd-41ba-4b0e-b165-e3a28ac5796b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westchase Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-b3a7-7648-bce1-5329472c8ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-b3a7-7648-bce1-5329472c8ac5",
        "storage_key": "property/6737460151191772/019e1e1d-b3a7-7648-bce1-5329472c8ac5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396743279492684688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-park-and-ride",
      "poi_latitude": "29.717204",
      "poi_longitude": "-95.5628297",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7f7-7039-9ac9-d3d2b5208327",
        "storage_key": "property/6737460151191772/019e1e1d-c7f7-7039-9ac9-d3d2b5208327.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX9fwSrdQIYRkFsjZmsV5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_2d5e1eff-731b-46b7-82d6-92e765f94b00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Hillcroft METRO Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9139043739511785172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillcroft-metro-park-and-ride",
      "poi_latitude": "29.722588",
      "poi_longitude": "-95.49586",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5pDIcvDQIYR1IZbQNxn1H4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_9e49c703-c25e-4c5f-9f49-b8e177b91aef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westheimer Rd @ Gessner Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-aeea-72cf-99dd-36904f739344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-aeea-72cf-99dd-36904f739344",
        "storage_key": "property/6737460151191772/019e1e1d-aeea-72cf-99dd-36904f739344.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2360571458105195953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westheimer-rd--gessner-rd",
      "poi_latitude": "29.7370197",
      "poi_longitude": "-95.5395494",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZw1L4BXDQIYRsT1J-ztvwiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7c5b7268-cf49-44e1-a797-772251ea920a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Bellaire Blvd @ S Gessner Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=872944211965729089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellaire-blvd--s-gessner-rd",
      "poi_latitude": "29.704863",
      "poi_longitude": "-95.537413",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-ZPG-nCQIYRQVnzviJSHQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_4885ab05-75fd-4353-9f43-dea032cd86b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "S Gessner Rd @ Westpark Dr",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3051986389815390672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-gessner-rd--westpark-dr",
      "poi_latitude": "29.72266399999999",
      "poi_longitude": "-95.539285",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzD6Ch_DQIYR0PFFkHPVWio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_e8cd0cd6-4cce-43c2-bfc6-e26e67b3d5c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "William P. Hobby Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7800 Airport Blvd, Houston, TX 77061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-ad7a-77f4-a498-8100ce348beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-ad7a-77f4-a498-8100ce348beb",
        "storage_key": "property/6737460151191772/019e1e1d-ad7a-77f4-a498-8100ce348beb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fly2houston.com/hou/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811035190079821913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-p-hobby-airport",
      "poi_latitude": "29.6459141",
      "poi_longitude": "-95.2768951",
      "poi_miles_from_property": "21.2",
      "poi_walking_minutes": "8 hours 0 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 713-640-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-c7bb-739c-b6b9-61aa564f5d38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1d-c7bb-739c-b6b9-61aa564f5d38",
        "storage_key": "property/6737460151191772/019e1e1d-c7bb-739c-b6b9-61aa564f5d38.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2ZP70-WQIYRWZj03jmDCJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_c58e05b3-ff7f-4d2b-bd5b-8f1597087881",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Woodlake Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2600 S Gessner Rd, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.whitestonereit.com/communities/?propertyId=houston-tx-west-memorial-office",
      "poi_directions_map_url": "https://maps.google.com/?cid=4689773744834529439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodlake-plaza",
      "poi_latitude": "29.738515",
      "poi_longitude": "-95.539147",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 713-435-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmed2rxTDQIYRn8jQmV9sFUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_bf3aaabd-ddf2-42b2-874f-7bea64c418ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12141 Richmond Ave, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-98ac-752f-8547-84fa8c0c1ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-98ac-752f-8547-84fa8c0c1ed4",
        "storage_key": "property/6737460151191772/019e1e1b-98ac-752f-8547-84fa8c0c1ed4.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/west?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=266204689841745394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-west",
      "poi_latitude": "29.7288209",
      "poi_longitude": "-95.5942013",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-558-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8bf-7796-84e0-8518c658398b",
        "storage_key": "property/6737460151191772/019e1e1b-d8bf-7796-84e0-8518c658398b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5byGn_rcQIYR8m2PR8G_sQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d82846d7-3c53-433a-9103-b5a1b93bf181",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Houston City College - Alief Hayes Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2811 Hayes Rd, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-895c-7545-92e6-e4a5eb30614c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-895c-7545-92e6-e4a5eb30614c",
        "storage_key": "property/6737460151191772/019e1e1b-895c-7545-92e6-e4a5eb30614c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hccs.edu/locations/northwest-college/alief-hayes-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7626777246185878854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---alief-hayes-campus",
      "poi_latitude": "29.7336019",
      "poi_longitude": "-95.5748367",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-718-2339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d962-70ab-820a-1f29eba920f2",
        "storage_key": "property/6737460151191772/019e1e1b-d962-70ab-820a-1f29eba920f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD2aIxsXcQIYRRvXwO3_B12k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7b9d8dd2-916a-4f3e-af91-f692aa05b3d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Westchase District Community Fund",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10370 Richmond Ave # 1350, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-af66-7069-ba32-0e1b84990e4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-af66-7069-ba32-0e1b84990e4f",
        "storage_key": "property/6737460151191772/019e1e1d-af66-7069-ba32-0e1b84990e4f.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "http://wdcfund.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10339591530154546067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-district-community-fund",
      "poi_latitude": "29.7282036",
      "poi_longitude": "-95.5563957",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-780-9434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzkdnS7DQIYRk9N_FbebfY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_6fdccdc6-d798-4649-8fa5-d48e97103283",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "CityWest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2103 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-b85d-7572-8bc6-ce3b0082252a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-b85d-7572-8bc6-ce3b0082252a",
        "storage_key": "property/6737460151191772/019e1e1d-b85d-7572-8bc6-ce3b0082252a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.citywesthouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782394134118006672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citywest",
      "poi_latitude": "29.7416791",
      "poi_longitude": "-95.5587417",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-822-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDAiErDQIYRkP_XfQVWvBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_07d091f3-bbf6-4822-b906-a04b79ecb167",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2331 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-a07c-77bc-9574-b534a78e73cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-a07c-77bc-9574-b534a78e73cb",
        "storage_key": "property/6737460151191772/019e1e1b-a07c-77bc-9574-b534a78e73cb.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.phillips66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860930961646065326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "29.7405404",
      "poi_longitude": "-95.5609181",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb3nsDrDQIYRrpbov6xYHdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_93f6cc06-5617-4dfe-b3bf-b74838ea5bb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "NOV",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10353 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-b3a3-720d-a870-255e6b93e7e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-b3a3-720d-a870-255e6b93e7e6",
        "storage_key": "property/6737460151191772/019e1e1d-b3a3-720d-a870-255e6b93e7e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nov.com/?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6680694165543904663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nov",
      "poi_latitude": "29.72716939999999",
      "poi_longitude": "-95.5554922",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-223-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVT6tGyXDQIYRl-VEnvKXtlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_35d4b85c-6ec0-49b0-a506-10088a37fb06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "poi_name": "Briarpark Green",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3151 Briarpark Dr Suite 200, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1d-b82e-77b0-b82b-c34d9c87feb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1d-b82e-77b0-b82b-c34d9c87feb8",
        "storage_key": "property/6737460151191772/019e1e1d-b82e-77b0-b82b-c34d9c87feb8.webp",
        "width": 894,
        "height": 1280
      },
      "poi_business_url": "https://graniteprop.com/briarpark-green",
      "poi_directions_map_url": "https://maps.google.com/?cid=16743536125980535837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briarpark-green",
      "poi_latitude": "29.7317943",
      "poi_longitude": "-95.5481932",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-572-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-d8ba-75d4-8325-3303354c1d44",
        "storage_key": "property/6737460151191772/019e1e1b-d8ba-75d4-8325-3303354c1d44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ258fATnDQIYRHWz9QGX9XOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_2887761b-ed73-4971-9cb9-852eef437d64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_e3f5c1fd-3407-4cfb-bba5-56618391d87a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_85428b55-bbe3-47d7-92c8-315d1144729b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_a3632fdb-67e7-4b5a-95a4-70c3a532be02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_b26bc72e-bad0-46e5-b01c-7db6d1c1f9dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_dbe1f3ac-d632-4c75-890e-5cf2f0266061",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d720b709-8c53-4fc9-af83-f11f0f19f952",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "rating": "5",
      "name": "Indiana Denizard",
      "text": "This place is awesome to stay at! The staff and the agents are always so kind and the apartments and super spacey and nice! Love it here 🙏",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "custom_bb4bc5e9-9afd-4dd6-9d75-8e05244d2c28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "rating": "5",
      "name": "Nick",
      "text": "The staff is so nice and they always go the extra mile to make us comfortable. Amazing place highly recommend!",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "custom_3da1c31a-273e-4e9f-b61b-41753c79c61e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "rating": "5",
      "name": "Shiloh Bertrand",
      "text": "We’ve had a fairly positive experience living here so far. The apartment itself is very spacious, and the amenities are nice and well maintained. One thing we’ve especially appreciated is how responsive the staff has been; whenever we’ve reached out with questions or maintenance requests they’ve been quick to assist.\n\nThe gym is also a huge plus. It’s well equipped and makes it easy to maintain a workout routine without needing an outside membership. Overall, it’s been a comfortable place to live and we’d definitely recommend it to others looking for an apartment in the area.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "custom_621e2e66-1091-4710-8b10-485e37dce211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "rating": "5",
      "name": "Michael Burry",
      "text": "⭐️⭐️⭐️⭐️⭐️\n\nVentura Lofts has been a great place to stay. The apartments have a clean, modern feel, the location is convenient, and the overall atmosphere has been comfortable and welcoming. The staff has been helpful and professional, and I’ve really appreciated how easy they’ve made the living experience.\n\nThe property itself has a nice vibe, and it’s been a solid place to come back to after long days. I’d definitely recommend Ventura Lofts to anyone looking for a good apartment community in the Houston area!",
      "date": "2026-05-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3b0c5b2c-f940-4c87-9aed-3a2d3b7f0e03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019e1e1b-753d-71ec-ae56-abfd3b2a9059.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e1b-753d-71ec-ae56-abfd3b2a9059",
        "storage_key": "property/6737460151191772/019e1e1b-753d-71ec-ae56-abfd3b2a9059.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6840753e2cdd6b14a3d84e17"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01994001-4a70-774a-bf86-9aeb9b9ae414",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-ventura-lofts-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772"
    },
    {
      "lead_collector_id": "019a502d-3af1-757f-a0ba-64e54f90e954",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-ventura-lofts-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-houston-tx",
      "search_query": "luxury apartments with a pool houston tx",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with a Pool in Houston, TX",
      "h2_subtitle": "Experience luxurious living in Houston with stunning pool access. Discover Ventura Lofts Apartments, your oasis of comfort and style.",
      "page_copy": "Dive into luxury at Ventura Lofts Apartments, where our stunning pool offers a refreshing retreat in Houston, TX. Our premium one, two, and three-bedroom apartments provide an upscale living environment complemented by state-of-the-art amenities, including a thoughtfully designed courtyard and sauna. Located in the vibrant Woodlake-Briar Meadow neighborhood, residents enjoy both luxury and convenience in Harris County.\n\nBeyond our sparkling pool, Ventura Lofts Apartments cater to all your lifestyle needs. Stay active in our modern fitness center, unwind on the rooftop terrace, or socialize in the stylish gameroom. Our pet-friendly community ensures a welcoming environment for every member of the family. Discover the elegance and comfort of our luxury apartments today. Schedule a tour to see what makes us the perfect home in Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with a Pool - Houston, TX",
      "seo_description": "Discover luxury living in Houston with a pool at Ventura Lofts Apartments. Explore our amenities and stylish homes today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "ventura-lofts-air-conditioned-apartments",
      "search_query": "ventura lofts air conditioned apartments",
      "category": "Amenity",
      "h1_title": "Ventura Lofts Air Conditioned Apartments",
      "h2_subtitle": "Stay comfortable year-round at Ventura Lofts. Our air-conditioned apartments in Houston offer top-notch amenities and superior living spaces.",
      "page_copy": "Enjoy the ultimate comfort with air-conditioned apartments at Ventura Lofts in Houston, TX. Our apartments are designed to provide a cool, inviting atmosphere that elevates your living experience. Choose from one, two, or three-bedroom floor plans that offer not just air conditioning but a host of exceptional amenities, including a fitness center, rooftop terrace, and a vibrant gameroom.\n\nLocated in the lively Woodlake-Briar Meadow area, our community offers controlled access and is cable ready, ensuring convenience meets luxury. Enjoy leisurely days in our courtyard or rejuvenate in our sauna. Ventura Lofts Apartments cater to all lifestyles, with features that make your home here not just livable, but enjoyable. Make the move today and experience the blend of comfort and style we offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ventura Lofts Air Conditioned Apartments",
      "seo_description": "Stay cool in Houston with air-conditioned units at Ventura Lofts Apartments. Discover comfortable, luxury living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "apartments-walk-in-closets-woodlake-briar-meadow",
      "search_query": "apartments with walk-in closets woodlake-briar meadow",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-in Closets in Woodlake-Briar Meadow",
      "h2_subtitle": "Discover spacious living in Woodlake-Briar Meadow. Our apartments feature generous walk-in closets and a host of other modern amenities.",
      "page_copy": "Step into spacious sophistication at Ventura Lofts Apartments in the Woodlake-Briar Meadow neighborhood. Our thoughtfully designed apartments boast walk-in closets, offering ample storage and seamless organization for your personal belongings. Choose from our selection of one, two, and three-bedroom floor plans, each designed to enhance your lifestyle with generous storage and modern conveniences.\n\nBeyond expansive closets, Ventura Lofts provides residents with top-tier amenities. From a state-of-the-art fitness center to a serene rooftop terrace and engaging gameroom, our community ensures all your needs are met, right here in Houston. Experience premium living with controlled access and pet-friendly policies, making Ventura Lofts the ideal place for you and your furry friends. Schedule a tour today to explore your stylish new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodlake-Briar Meadow Apartments with Walk-in Closets",
      "seo_description": "Find spacious apartments with walk-in closets in Woodlake-Briar Meadow at Ventura Lofts. Enjoy modern amenities and a prime location in Houston.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "apartments-washer-dryer-harris-county",
      "search_query": "apartments with washer dryer harris county",
      "category": "Amenity",
      "h1_title": "Harris County Apartments with Washer Dryer",
      "h2_subtitle": "Enjoy the convenience of in-unit washer and dryer at Ventura Lofts. Find your dream home in Harris County with modern amenities and comfort.",
      "page_copy": "Ventura Lofts Apartments in Harris County offers the ultimate convenience with in-unit washer and dryer facilities. Perfect for those looking to combine luxury with practicality, our one, two, and three-bedroom floor plans are designed for modern living. Say goodbye to communal laundries and hello to comfort and ease in your new home.\n\nOur community, nestled in the vibrant Woodlake-Briar Meadow area of Houston, provides much more than just laundry conveniences. Enjoy exclusive access to amenities like a cutting-edge fitness center, relaxing sauna, and a beautifully maintained courtyard. With pet-friendly policies and a secure, controlled access, Ventura Lofts Apartments cater to a superior lifestyle that meets all your needs. Discover the perfect blend of luxury and functionality today by scheduling a visit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Harris County Apartments with Washer and Dryer",
      "seo_description": "Find Harris County living at its best with in-unit washer and dryer at Ventura Lofts. Discover luxury and convenience in Houston today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-houston-tx",
      "search_query": "fitness center apartments in houston tx",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Houston, TX",
      "h2_subtitle": "Stay active and healthy at Ventura Lofts in Houston. Our on-site fitness center offers modern equipment and a welcoming environment for all residents.",
      "page_copy": "Discover the ideal blend of fitness and luxury at Ventura Lofts Apartments in Houston, TX. Our on-site fitness center is designed to support a healthy lifestyle, equipped with state-of-the-art machines and a welcoming atmosphere perfect for any workout routine. Whether you’re into cardio or weight training, you’ll find everything you need right here.\n\nLocated in the vibrant Woodlake-Briar Meadow area, Ventura Lofts offers more than just fitness amenities. Choose from our spacious one, two, or three-bedroom floor plans, each complementing your active lifestyle with a sauna, rooftop terrace, and engaging gameroom. With controlled access and a pet-friendly environment, our community is built for convenience and enjoyment. Join us today and elevate your living experience in Houston!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Houston, TX",
      "seo_description": "Stay fit at Ventura Lofts Apartments with a modern fitness center. Enjoy luxury living in Houston's Woodlake-Briar Meadow neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-woodlake-briar-meadow",
      "search_query": "one bedroom apartments in Woodlake-Briar Meadow",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Woodlake-Briar Meadow",
      "h2_subtitle": "Find your ideal one-bedroom apartment at Ventura Lofts. Experience comfort and convenience in the heart of Woodlake-Briar Meadow.",
      "page_copy": "Escape into a world of style and comfort at Ventura Lofts Apartments, where our one-bedroom units in Woodlake-Briar Meadow offer the perfect urban retreat. Thoughtfully designed to maximize space and light, these apartments provide an ideal setting for both relaxation and entertainment, featuring modern interiors and rich amenities.\n\nIn addition to stylish living spaces, you’ll enjoy access to extraordinary community features including a relaxing sauna, vibrant gameroom, and inviting courtyard. Situated in Houston, TX, our location provides easy access to the dynamic lifestyle of the Woodlake-Briar Meadow neighborhood, complete with shopping, dining, and leisure options. Come home to Ventura Lofts today, where convenience and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Woodlake-Briar Meadow",
      "seo_description": "Explore one-bedroom apartments at Ventura Lofts. Discover style and convenience in Woodlake-Briar Meadow, Houston.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-houston-tx",
      "search_query": "two bedroom apartments Houston TX",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Houston, TX",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Ventura Lofts. Enjoy modern living in Houston, TX with exceptional amenities right at home.",
      "page_copy": "Ventura Lofts Apartments provide the perfect setting for vibrant city living with our spacious and well-appointed two-bedroom apartments in Houston, TX. Each unit is designed with modern comforts and style in mind, making it ideal for anyone seeking ample living space and functionality. Enjoy cooking and entertaining in a sophisticated environment that feels like home.\n\nBeyond your apartment doors, Ventura Lofts offers a variety of amenities, including a state-of-the-art fitness center, a relaxing sauna, and a beautiful courtyard that enhances your living experience. Located in the lively Woodlake-Briar Meadow area, our community is nestled among top-notch dining, shopping, and entertainment options. Choose Ventura Lofts for a lifestyle that fits your needs perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Houston, TX",
      "seo_description": "Discover spacious two-bedroom apartments at Ventura Lofts in Houston, TX. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191772",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-77063",
      "search_query": "three bedroom apartments 77063",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 77063",
      "h2_subtitle": "Explore our expansive three-bedroom apartments in the 77063 area. Ventura Lofts offers the perfect blend of space, style, and community amenities.",
      "page_copy": "Welcome to Ventura Lofts Apartments, where our spacious three-bedroom units in the 77063 area provide unparalleled comfort and style. Perfect for families or roommates, these apartments offer roomy interiors designed with modern aesthetics and practical amenities in mind. Experience the joy of living in a community that values quality and luxury.\n\nAt Ventura Lofts, residents enjoy access to top-tier amenities, such as a fitness center equipped with the latest workout gear, a serene sauna, and a vibrant gameroom perfect for relaxing after a long day. Situated in Houston's desirable Woodlake-Briar Meadow neighborhood, our community is close to shopping, dining, and entertainment options. Make Ventura Lofts your new home and enjoy an elevated living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment complex courtyard with a luminous swimming pool and lush palm trees.",
        "public_id": "019d076f-5af1-70bf-bedb-fdbef375da13",
        "storage_key": "property/6737460151191772/019d076f-5af1-70bf-bedb-fdbef375da13.webp",
        "width": 1080,
        "height": 764
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 77063",
      "seo_description": "Discover spacious three-bedroom apartments at Ventura Lofts in the 77063 area. Enjoy modern living with abundant community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3413"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483187"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4871564"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PWVGQRKK"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "832-905-0573"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "832-743-2065"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "832-400-1286"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "832-430-7595"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "832-639-6343"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "832-861-0818"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "832-479-2523"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "832-669-4875"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "832-558-5797"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "832-905-1873"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "832-753-6001"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-470-2336"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-273-5607"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "832-376-6560"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "832-430-7214"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "832-937-4965"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "832-737-8851"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321213544"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "832-304-8386"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "832-979-2431"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "93e151011ee45c8e"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-321-9787"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "832-219-8564"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "832-234-9807"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "832-905-1408"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "832-737-2472"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "832-430-1675"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "832-551-3641"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.venturalofts-houston.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "832-861-7797"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-558-5797"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3413",
  "custom_repli_id": "5028483187",
  "custom_realpage_id": "4871564",
  "custom_knock_g_link": "https://www.venturalofts-houston.com?utm_knock=g",
  "custom_knock_r_link": "https://www.venturalofts-houston.com?utm_knock=r",
  "custom_knock_w_link": "https://www.venturalofts-houston.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-PWVGQRKK",
  "custom_knock_al_link": "https://www.venturalofts-houston.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.venturalofts-houston.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.venturalofts-houston.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.venturalofts-houston.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.venturalofts-houston.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.venturalofts-houston.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_ads_link": "https://www.venturalofts-houston.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.venturalofts-houston.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "832-905-0573",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.venturalofts-houston.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.venturalofts-houston.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.venturalofts-houston.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.venturalofts-houston.com?utm_knock=psa",
  "custom_knock_r_number": "832-743-2065",
  "custom_knock_w_number": "832-400-1286",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "832-430-7595",
  "custom_knock_amap_link": "https://www.venturalofts-houston.com?utm_knock=amap",
  "custom_knock_ar_number": "832-639-6343",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "832-861-0818",
  "custom_knock_fb_number": "832-479-2523",
  "custom_knock_fl_number": "832-669-4875",
  "custom_knock_gp_number": "832-558-5797",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.venturalofts-houston.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "832-905-1873",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.venturalofts-houston.com?utm_knock=bcard",
  "custom_knock_bnr_number": "832-753-6001",
  "custom_knock_cfres_link": "https://www.venturalofts-houston.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-470-2336",
  "custom_knock_lgp_number": "361-273-5607",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.venturalofts-houston.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "832-376-6560",
  "custom_knock_psa_number": "832-430-7214",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "832-937-4965",
  "custom_knock_bandit_link": "https://www.venturalofts-houston.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.venturalofts-houston.com?utm_knock=flyers",
  "custom_knock_osoc_number": "832-737-8851",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321213544",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "832-304-8386",
  "custom_knock_cfres_number": "832-979-2431",
  "custom_knock_chatgpt_link": "https://www.venturalofts-houston.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "93e151011ee45c8e",
  "custom_knock_dirmail_link": "https://www.venturalofts-houston.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-321-9787",
  "custom_knock_propbro_link": "https://www.venturalofts-houston.com?utm_knock=propbro",
  "custom_knock_bandit_number": "832-219-8564",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "832-234-9807",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.venturalofts-houston.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "832-905-1408",
  "custom_knock_dirmail_number": "832-737-2472",
  "custom_knock_propbro_number": "832-430-1675",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "832-551-3641",
  "custom_knock_maintenance_link": "https://www.venturalofts-houston.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "832-861-7797",
  "custom_ppc_tracking_phone_number": "832-558-5797"
};

export const generatedAt = '2026-10-07T17:15:11.686Z';
